import React, { Component } from 'react'
import { Layout, Breadcrumb } from 'antd'
import './UserManagement.scss'
import { withRouter } from 'react-router-dom'
import TableEdit from '../../components/TableEdit/TableEdit'
const { Content } = Layout

class UserManagement extends Component {
  render() {
    return (
      <div className="UserManagementStyles">
        <Layout className="site-layout">
          <Content>
            <div className="layout_middel_content">
              <Breadcrumb>
                <Breadcrumb.Item>User Management</Breadcrumb.Item>
                <Breadcrumb.Item>List</Breadcrumb.Item>
              </Breadcrumb>
              <TableEdit />
            </div>
          </Content>
        </Layout>
      </div>
    )
  }
}

export default withRouter(UserManagement)
